<template>
    <div>
        <section class="modal-card-body has-text-left">
            <step-tracker></step-tracker>

            <loader class="mt" v-if="loading" />

            <div v-else>
                <h2 class="step-heading" v-t="`${langRoot}.reset.title`" />
                <p v-t="`${langRoot}.reset.helper`" />
                <new-password
                    :default-focus="true"
                    v-model="newPassword"
                    :lang-root="`${langRoot}.reset.setNewPassword`"
                />
            </div>
        </section>

        <footer class="modal-card-foot">
            <div class="level is-block">
                <div class="level-right is-pulled-right">
                    <!-- Submit Button -->
                    <button
                        @click="submit"
                        class="btn primary"
                        :class="{ inactive: !isValid }"
                        v-t="`${langRoot}.reset.submitBtn`"
                        data-ci="pr-step3-next-button"
                        :disabled="!isValid"
                    />
                </div>

                <div class="level-left is-pulled-left">
                    <!-- Cancel Button -->
                    <button
                        @click="cancel"
                        class="btn is-ghost"
                        v-t="`${langRoot}.reset.cancelBtn`"
                    />
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import StepTracker from './PasswordStepTracker';
import NewPassword from '@shared/components/NewPassword';
import loading from '@shared/mixins/loading';
import tracking from '@shared/mixins/tracking';

import { isEmpty } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

const name = 'passwordreset-reset';
export default {
    name,
    componentName: name,

    components: {
        [StepTracker.name]: StepTracker,
        [NewPassword.name]: NewPassword,
    },

    mixins: [loading, tracking],

    props: {
        langRoot: { type: String, required: true },
    },

    data() {
        return {
            newPassword: '',
            errorMessage: null,
        };
    },

    created() {
        if (isEmpty(this.questions)) {
            this.$router.replace({ name: 'Login' });
        }
    },

    computed: {
        ...mapGetters('passwordreset', ['getRecoveryQuestions']),
        questions() {
            return this.getRecoveryQuestions();
        },

        isValid() {
            return !isEmpty(this.newPassword);
        },
    },

    methods: {
        ...mapActions('passwordreset', ['resetPassword']),

        submit() {
            if (!this.isValid) {
                return;
            }

            this.$trackEvent(this.pageTag, 'submit');

            let payload = {
                password: this.newPassword,
            };

            this.startLoading();
            this.resetPassword(payload)
                .then(this.handleResponse)
                .catch(this.handleError)
                .finally(this.stopLoading);
        },

        handleResponse(response) {
            if (response.errorText) {
                this.handleError(response);
            } else {
                this.$router.replace({ name: 'passwordreset.complete' });
            }
        },
        handleError(error) {
            this.$router.replace({ name: 'Login', query: { error: true } });
        },

        cancel() {
            this.$trackEvent(this.pageTag, 'cancel');
            this.$router.push({ name: 'Login' });
        },
    },
};
</script>



// WEBPACK FOOTER //
// login/Components/PasswordResetNew.vue